import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { errorAccessToContractCreation } from "../../redux/actions/clientShortInfoAction";

const useClientValidation = ({ client, inactiveClient }) => {
  const dispatch = useDispatch();
  const [clientIdNumber, setClientNumber] = useState(false);

  useEffect(() => {
    const isInvalid = (!client?.personal || client?.personal === "-1") && client?.residency;
    setClientNumber(isInvalid);
  }, [client]);

  const errorMessages = {
    missingClientId:
      'Необходимо заполнить данные по клиенту по полю "Идентификационный номер"',
    inactiveClient:
      "Ошибка! Срок действия документа истек или документ неактивен.",
  };

  const validateClientId = (requiresClientId) => {
    if (clientIdNumber && requiresClientId) {
      dispatch(errorAccessToContractCreation(errorMessages.missingClientId));
      return true;
    }
    return false;
  };

  const validateClientStatus = () => {
    if (inactiveClient) {
      dispatch(errorAccessToContractCreation(errorMessages.inactiveClient));
    }
    if (clientIdNumber) {
      dispatch(errorAccessToContractCreation(errorMessages.missingClientId));
    }
  };

  return { validateClientId, validateClientStatus, clientIdNumber };
};

export default useClientValidation;
